import { Lexer, createToken } from "chevrotain";

import { TokenTypeName } from "@/models/parser";

// Base category tokens
export const Operator = createToken({
  name: TokenTypeName.Plus,
  pattern: Lexer.NA,
});

export const Function = createToken({
  name: TokenTypeName.FunctionName,
  pattern: Lexer.NA,
});

// Two-Character Operators (must be defined BEFORE single-character operators)
export const NotEquals = createToken({
  name: TokenTypeName.NotEquals,
  pattern: /!=/,
  categories: [Operator],
});

export const Equals = createToken({
  name: TokenTypeName.Equals,
  pattern: /==/,
  categories: [Operator],
});

export const LessEquals = createToken({
  name: TokenTypeName.LessEquals,
  pattern: /<=/,
  categories: [Operator],
});

export const GreaterEquals = createToken({
  name: TokenTypeName.GreaterEquals,
  pattern: />=/,
  categories: [Operator],
});

export const LogicalAnd = createToken({
  name: TokenTypeName.LogicalAnd,
  pattern: /&&/,
  categories: [Operator],
});

export const LogicalOr = createToken({
  name: TokenTypeName.LogicalOr,
  pattern: /\|\|/,
  categories: [Operator],
});

// Single-Character Operators
export const Plus = createToken({
  name: TokenTypeName.Plus,
  pattern: /\+/,
  categories: [Operator],
});

export const Minus = createToken({
  name: TokenTypeName.Minus,
  pattern: /-/,
  categories: [Operator],
});

export const Star = createToken({
  name: TokenTypeName.Star,
  pattern: /\*/,
  categories: [Operator],
});

export const Slash = createToken({
  name: TokenTypeName.Slash,
  pattern: /\//,
  categories: [Operator],
});

export const Percent = createToken({
  name: TokenTypeName.Percent,
  pattern: /%/,
  categories: [Operator],
});

export const Caret = createToken({
  name: TokenTypeName.Caret,
  pattern: /\^/,
  categories: [Operator],
});

export const LessThan = createToken({
  name: TokenTypeName.LessThan,
  pattern: /</,
  categories: [Operator],
});

export const GreaterThan = createToken({
  name: TokenTypeName.GreaterThan,
  pattern: />/,
  categories: [Operator],
});

// Delimiters
export const LeftParenthesis = createToken({
  name: TokenTypeName.LeftParenthesis,
  pattern: /\(/,
});

export const RightParenthesis = createToken({
  name: TokenTypeName.RightParenthesis,
  pattern: /\)/,
});

export const LeftBracket = createToken({
  name: "LeftBracket",
  pattern: /\[/,
});

export const RightBracket = createToken({
  name: "RightBracket",
  pattern: /\]/,
});

export const Comma = createToken({
  name: TokenTypeName.Comma,
  pattern: /,/,
});

// Context Markers
export const LeftBrace = createToken({
  name: "LeftBrace",
  pattern: /\{/,
});

export const RightBrace = createToken({
  name: "RightBrace",
  pattern: /\}/,
});

export const Colon = createToken({
  name: "Colon",
  pattern: /:/,
});

// Literals
export const InvalidIdentifier = createToken({
  name: TokenTypeName.InvalidIdentifier,
  pattern: /\d+[a-zA-Z_][a-zA-Z0-9_]*/,
});

export const NumberLiteral = createToken({
  name: TokenTypeName.NumberLiteral,
  pattern: /\d+\.?\d*/,
});

export const StringLiteral = createToken({
  name: TokenTypeName.StringLiteral,
  pattern: /"[^"]*"|'[^']*'/,
});

export const IncompleteString = createToken({
  name: TokenTypeName.IncompleteString,
  pattern: /"[^"]*|'[^']*/,
});

// Identifiers
export const FunctionName = createToken({
  name: TokenTypeName.FunctionName,
  pattern: /[A-Z][a-zA-Z0-9_]*/,
  categories: [Function],
});

export const AttributeName = createToken({
  name: TokenTypeName.AttributeName,
  pattern: /:?[a-z_][a-zA-Z0-9_]*/,
});

export const WhiteSpace = createToken({
  name: TokenTypeName.WhiteSpace,
  pattern: /\s+/,
});

// All tokens in priority order
export const allTokens = [
  WhiteSpace,

  // Literals (before operators to match negative numbers)
  InvalidIdentifier,
  NumberLiteral,
  StringLiteral,
  IncompleteString,

  // Two-character operators (must come before single-character)
  NotEquals,
  Equals,
  LessEquals,
  GreaterEquals,
  LogicalAnd,
  LogicalOr,

  // Single-character operators
  Plus,
  Minus,
  Star,
  Slash,
  Percent,
  Caret,
  LessThan,
  GreaterThan,

  // Delimiters
  LeftParenthesis,
  RightParenthesis,
  LeftBracket,
  RightBracket,
  Comma,

  // Context markers
  LeftBrace,
  RightBrace,

  // Identifiers (must come last to avoid matching keywords)
  FunctionName,
  AttributeName,

  // Colon for JSON context (must be after AttributeName to not split :attribute)
  Colon,
];

// Create the lexer instance
export const AttributeBuilderLexer = new Lexer(allTokens);
